module.exports = __webpack_public_path__ + "img/neteller.f08d2abb.svg";